/**
 * TemplatesPage -- Browse available resume templates.
 *
 * Grid of template thumbnail cards showing name, description,
 * and PDF/Word support badges.
 */
import { useEffect } from 'react';
import { useSiteStore, useSiteActions } from '../../state/cms/useSiteStore';
import { LoadingState } from '../../components/ui/LoadingState';
import { logger } from '../../services/logger.client';

const log = logger.child({ module: 'TemplatesPage' });

export function TemplatesPage() {
  const templates = useSiteStore((s) => s.templates);
  const isLoading = useSiteStore((s) => s.isLoading);
  const error = useSiteStore((s) => s.error);
  const { fetchTemplates } = useSiteActions();

  useEffect(() => {
    log.info('TemplatesPage mounted');
    void fetchTemplates();
  }, [fetchTemplates]);

  return (
    <div className="cms-page">
      <header className="cms-page__header">
        <h1 className="cms-page__title">Templates</h1>
      </header>

      <LoadingState loading={isLoading} error={error}>
        {templates.length === 0 ? (
          <div className="list-empty">
            No templates available. Add template folders to the templates/ directory.
          </div>
        ) : (
          <div className="cms-template-grid cms-template-grid--browse">
            {templates.map((tpl) => (
              <div key={tpl.id} className="cms-template-browse-card">
                <div className="cms-template-browse-card__thumb">
                  {tpl.thumbnail_url ? (
                    <img
                      src={tpl.thumbnail_url}
                      alt={tpl.name}
                      className="cms-template-browse-card__img"
                    />
                  ) : (
                    <span className="cms-template-card__placeholder">
                      {tpl.name.charAt(0).toUpperCase()}
                    </span>
                  )}
                </div>
                <div className="cms-template-browse-card__info">
                  <h3 className="cms-template-browse-card__name">{tpl.name}</h3>
                  <p className="cms-template-browse-card__desc">{tpl.description}</p>
                  <p className="cms-template-browse-card__version">v{tpl.version}</p>
                  <div className="cms-template-browse-card__badges">
                    {tpl.supports_pdf && (
                      <span className="badge badge--active">PDF</span>
                    )}
                    {tpl.supports_word && (
                      <span className="badge badge--active">Word</span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </LoadingState>
    </div>
  );
}
